import { required, minLength } from 'vuelidate/lib/validators';

const validations = {
  title: {
    required,
  },
  abbreviation: {
    required,
    minLength: minLength(2)
  },
  dialingCode: {
    required,
  },
};

export default validations;